import { render, staticRenderFns } from "./InventoryBulkContainersTransactions.vue?vue&type=template&id=3c8c8bb7&"
import script from "./InventoryBulkContainersTransactions.vue?vue&type=script&lang=js&"
export * from "./InventoryBulkContainersTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports